// src/pages/MPFlow/components/targeting/BudgetInput.jsx
import React from 'react';

const PRESETS = [10, 20, 50, 100, 200, 500];

export default function BudgetInput({ value = 20, onChange }) {
  const handleSlider = (e) => onChange(Number(e.target.value));

  return (
    <div className="seg-budget">
      <div className="seg-budget__display">
        <span className="seg-budget__currency">R$</span>
        <span className="seg-budget__amount">{value}</span>
        <span className="seg-budget__period">/dia</span>
      </div>

      <input
        type="range"
        min={5}
        max={1000}
        step={5}
        value={value}
        onChange={handleSlider}
        className="seg-budget__slider"
      />

      <div className="seg-budget__presets">
        {PRESETS.map((p) => (
          <button
            key={p}
            type="button"
            className={`seg-budget__preset ${value === p ? 'seg-budget__preset--active' : ''}`}
            onClick={() => onChange(p)}
          >
            R$ {p}
          </button>
        ))}
      </div>

      <div className="seg-budget__estimate">
        Estimativa: {Math.round(value * 30 * 15)} – {Math.round(value * 30 * 40)} pessoas alcançadas/mês
      </div>
    </div>
  );
}
